import React from 'react';

type Props = {
  className?: string;
  templateIds: string[];
};

export const ZapTemplate: React.FC<Props> = ({
  templateIds,
  className,
}: Props) => {
  const ids = templateIds.join(',');
  return (
    <div className={className}>
      <div
        dangerouslySetInnerHTML={{
          __html: `
        <script type="text/javascript" src="https://zapier.com/zapbook/embed/widget.js?guided_zaps=${ids}"></script>
        `,
        }}
      />
    </div>
  );
};
